import { useId } from 'react';
import { Select } from '@/components/ui';

export interface PolicySelectOption<V extends string> {
  value: V;
  label: string;
}

export interface PolicySelectRowProps<V extends string> {
  label: string;
  description?: string;
  value: V;
  options: ReadonlyArray<PolicySelectOption<V>>;
  disabled?: boolean;
  onChange: (next: V) => void;
  testId?: string;
}

/**
 * 라벨 + 보조설명 + 우측 select 1행. 장바구니 정책의 enum 3필드(담기 후 이동·중복 정책·
 * 품절 정책) 공용 레이아웃. label 을 select 와 연결(htmlFor)해 라벨 클릭으로 포커스되도록 한다.
 * onChange 는 옵션 value 타입으로 좁혀 전달한다(enum 안전성).
 */
export const PolicySelectRow = <V extends string>({
  label,
  description,
  value,
  options,
  disabled,
  onChange,
  testId,
}: PolicySelectRowProps<V>) => {
  const id = useId();
  return (
    <div className="flex items-start justify-between gap-4 py-3">
      <div className="flex flex-col gap-0.5">
        <label
          htmlFor={id}
          className="text-sm font-medium text-[color:var(--content-strong)]"
        >
          {label}
        </label>
        {description ? (
          <span className="text-xs text-[color:var(--content-muted)]">{description}</span>
        ) : null}
      </div>
      <Select
        id={id}
        className="w-52"
        disabled={disabled}
        value={value}
        onChange={(e) => onChange(e.target.value as V)}
        data-testid={testId}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Select>
    </div>
  );
};
